import { API } from "aws-amplify";

export async function getOverrideZoneSchedule(companyId: string): Promise<{ from: string, to: string }[]> {
  try {
    const path: string = `/geofence/override?companyId=${companyId}`;
    const response = await API.get('api-service', path, {});
    return response.data || [];
  } catch (error) {
    console.log(error);
    throw error;
  }
}